// const BASE_URLS = {
//     development: "http://localhost:5001/",
//     production: "http://localhost:5001/",
//     local: "http://localhost:5001/",
// };

const BASE_URLS = {
  development: 'https://api.forum.prod.go-out.co/',
  production: 'https://api.forum.prod.go-out.co/',
  local: 'http://localhost:5001/',
};

const API_URL = BASE_URLS.production;
export const DISTRIBUTION_URL = 'https://d15q6k8l9pfut7.cloudfront.net/';
export const apiConfig = Object.freeze({
  login: `${API_URL}auth/login`,
  admin: {
    insertUser: `${API_URL}admin/insertUser`,
    getAdmin: `${API_URL}admin/getAdmin`,
    sendOTP: `${API_URL}admin/sendOTP`,
    verifyOTP: `${API_URL}admin/verifyOTP`,
    crmUsers: `${API_URL}admin/crm-users`,
    getAllAdmins: `${API_URL}admin/getAllAdmins`,
    approveUser: `${API_URL}admin/users/approve`,
  },
  forumSettings: {
    getAbout: `${API_URL}forum-settings/get-about`,
    updateAbout: `${API_URL}forum-settings/update-about`,
    updateEvents: `${API_URL}forum-settings/update-events`,
    getIAM: `${API_URL}forum-settings/get-iam`,
    updateIAMConfig: `${API_URL}forum-settings/update-iam-config`,
    getModalBanners: `${API_URL}forum-settings/get-modal-banners`,
    updateModalBanners: `${API_URL}forum-settings/update-modal-banners`,
  },
  event: {
    eventsFromConfig: `${API_URL}event/events-from-config`,
  },
  media: {
    uploadImage: `${API_URL}media/get-presigned-url`,
  },
});
